module.exports = require('./ZEventsApiLanguages')
